export const BOOK_CALL_URL = "https://calendly.com/daniel-jindoo-doomade/doomade";
export const YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@Jinni_Doo";
export const SUBSTACK_URL = "https://danieljindoo.substack.com/";
export const SUBSTACK_SUBSCRIBE_URL = "https://danieljindoo.substack.com/subscribe";
export const DISCORD_INVITE_URL = "https://discord.gg/HmbPtVy6Eq";

